export const RELEASED = 'RELEASED' as const;
export const UNRELEASED = 'UNRELEASED' as const;
export const ARCHIVED = 'ARCHIVED' as const;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default [RELEASED, UNRELEASED, ARCHIVED];
